export const GET_ALL_TASKS = 'GET_ALL_TASKS';
export const GET_TASK = 'GET_TASK';
